<template>
  <div id="app" v-cloak>
    <keep-alive exclude="">
      <router-view/>
    </keep-alive>
  </div>
</template>

<script>
//import CONFIG from '@/constants/config.js';
export default {
  name: 'App',
   components:{
  },
  data: () => ({
    //
  }),
  beforeCreate(){
  }
};
</script>

<style>
@import './assets/global.css';
</style>
